export default (t) => [
  {
    text: t('Name'),
    value: 'fullname',
    sortable: true,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Member Code'),
    value: 'member_code',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('National ID'),
    value: 'national_id',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Customer Group'),
    value: 'customer_group',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Phone'),
    value: 'telephone',
    sortable: false,
    width: 180,
    togglable: true
  },
  {
    text: t('Email'),
    value: 'email',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Line ID'),
    value: 'line_id',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 170,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
